import { useEffect } from 'react'
import ReactGA from 'react-ga'

ReactGA.initialize('UA-68896972-2')

export default function GAListener({ location }) {

    const page = location.pathname + location.search

    useEffect(() => {
        if (
            !page.includes('/oauth/')
            && !page.includes('/a/')
            && !page.includes('/r/')
            && !page.includes('/c/')
        ) {
            ReactGA.set({ page })
            ReactGA.pageview(page)
        }
    }, [page])
    return null
}